// Error types for API responses
export const ERROR_TYPES = {
  RATE_LIMITED: 'RATE_LIMITED',
  DUPLICATE_ACCOUNT: 'DUPLICATE_ACCOUNT',
  GENERIC: 'GENERIC',
} as const;

export type ErrorType = typeof ERROR_TYPES[keyof typeof ERROR_TYPES];

// Custom error class that includes error type
export class ApiError extends Error {
  type: ErrorType;
  statusCode?: number;
  originalError?: any;

  constructor(message: string, type: ErrorType = ERROR_TYPES.GENERIC, statusCode?: number, originalError?: any) {
    super(message);
    this.name = 'ApiError';
    this.type = type;
    this.statusCode = statusCode;
    this.originalError = originalError;
  }
}
